///
/// EarthBrowser
///
/// Created by Matt Giger on 10/14/2025
/// Copyright (c) 2025 Geodata Labs
///

/**
 * Detects if the current device is a mobile device based on the user agent.
 * This is more reliable than width-based detection, especially when devices
 * are rotated (landscape vs portrait).
 *
 * Detects: iPhone, iPad, iPod, Android devices, Windows Phone, BlackBerry, and Opera Mini
 */
export function isMobile(): boolean {
	if (typeof navigator === 'undefined') return false
	return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export function isChrome(): boolean {
	const userAgent = navigator.userAgent
	return userAgent.includes("Chrome") && !userAgent.includes("Edge")
}

export function isSafari(): boolean {
	const userAgent = navigator.userAgent
	return userAgent.includes("Safari") && !userAgent.includes("Chrome")
}

export function isIOS(): boolean {
	if (typeof navigator === 'undefined') return false
	return /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
		(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
}

export function isIOSChrome(): boolean {
	if (typeof navigator === 'undefined') return false
	return isIOS() && /CriOS/i.test(navigator.userAgent)
}